import { StarHalfIcon } from './StarHalfIcon';

/**
 * author: Simran
 * id E86BFC0D-B4A4-41F2-A8E3-D1AE79072A45
 * name star-half
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-half.svg
 * tags
 * - Shape 
 */
export const FavoriteHalfIcon = StarHalfIcon;
export default FavoriteHalfIcon